export const CURRENCIES = [
  { code: 'INR', symbol: '₹',   name: 'Indian Rupee' },
  { code: 'USD', symbol: '$',   name: 'US Dollar' },
  { code: 'EUR', symbol: '€',   name: 'Euro' },
  { code: 'GBP', symbol: '£',   name: 'British Pound' },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
  { code: 'SGD', symbol: 'S$',  name: 'Singapore Dollar' },
  { code: 'AUD', symbol: 'A$',  name: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$',  name: 'Canadian Dollar' },
  { code: 'MYR', symbol: 'RM',  name: 'Malaysian Ringgit' },
  { code: 'SAR', symbol: '﷼',   name: 'Saudi Riyal' },
  { code: 'QAR', symbol: 'QR',  name: 'Qatari Riyal' },
  { code: 'KWD', symbol: 'KD',  name: 'Kuwaiti Dinar' },
  { code: 'JPY', symbol: '¥',   name: 'Japanese Yen' },
  { code: 'CNY', symbol: '¥',   name: 'Chinese Yuan' },
  { code: 'ZAR', symbol: 'R',   name: 'South African Rand' },
  { code: 'NGN', symbol: '₦',   name: 'Nigerian Naira' },
  { code: 'BDT', symbol: '৳',   name: 'Bangladeshi Taka' },
  { code: 'LKR', symbol: '₨',   name: 'Sri Lankan Rupee' },
  { code: 'NPR', symbol: '₨',   name: 'Nepalese Rupee' },
  { code: 'PKR', symbol: '₨',   name: 'Pakistani Rupee' },
];

const MAP = Object.fromEntries(CURRENCIES.map(c => [c.code, c.symbol]));

/** Returns the currency symbol for a given ISO code. Falls back to the code itself. */
export function currencySymbol(code) {
  return MAP[code] || code || '₹';
}

/** Formats a price with currency symbol and locale-aware number formatting. */
export function formatPrice(amount, currencyCode) {
  const sym = currencySymbol(currencyCode || 'INR');
  const locale = currencyCode === 'INR' ? 'en-IN' : 'en-US';
  const num = Number(amount);
  if (isNaN(num)) return `${sym}0`;
  return `${sym}${num.toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}
